import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * OAuth callback handler for SharePoint/Microsoft Graph.
 * This page opens in a popup window. On success it posts a message
 * to the opener window and closes itself.
 */
export default function SharePointCallback() {
  const [status, setStatus] = useState('processing'); // processing | success | error
  const [message, setMessage] = useState('Connecting to SharePoint…');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code  = params.get('code');
    const error = params.get('error');
    const state = params.get('state');

    if (error) {
      setStatus('error');
      setMessage(`Authorization failed: ${error}`);
      if (window.opener) {
        window.opener.postMessage({ type: 'SHAREPOINT_AUTH_ERROR', error }, window.location.origin);
        setTimeout(() => window.close(), 2000);
      }
      return;
    }

    if (!code) {
      setStatus('error');
      setMessage('No authorization code received');
      return;
    }

    // Exchange code for connection
    axios.post(`${API}/data-room/sharepoint/oauth/exchange`, {
      code,
      redirect_uri: `${window.location.origin}/sharepoint-callback`,
      state,
    })
      .then((res) => {
        setStatus('success');
        setMessage('SharePoint connected successfully!');
        if (window.opener) {
          window.opener.postMessage(
            { type: 'SHAREPOINT_AUTH_SUCCESS', connection: res.data },
            window.location.origin
          );
          setTimeout(() => window.close(), 1500);
        }
      })
      .catch((err) => {
        const detail = err.response?.data?.detail || 'Connection failed';
        setStatus('error');
        setMessage(detail);
        if (window.opener) {
          window.opener.postMessage({ type: 'SHAREPOINT_AUTH_ERROR', error: detail }, window.location.origin);
          setTimeout(() => window.close(), 2000);
        }
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
      <div className="text-center space-y-4 max-w-sm px-6">
        {status === 'processing' && (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-[#ffd87a] mx-auto" />
            <p className="text-[#a8a8a8] font-medium">{message}</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-10 h-10 text-green-500 mx-auto" />
            <p className="text-green-700 font-medium">{message}</p>
            <p className="text-sm text-[#a8a8a8]">This window will close automatically.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-10 h-10 text-red-500 mx-auto" />
            <p className="text-red-600 font-medium">{message}</p>
            <p className="text-sm text-[#a8a8a8]">You can close this window.</p>
          </>
        )}
      </div>
    </div>
  );
}
